import { render, staticRenderFns } from "./compareList.vue?vue&type=template&id=06f2d41e"
import script from "./compareList.vue?vue&type=script&lang=js"
export * from "./compareList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports